import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  onbLifeProofStatusApproved: 'Verification completed',
  onbLifeProofStatusDeclined:
    'An error occurred with your verification. Please try again.',
  onbLifeProof: 'Identity verification',
  onbLifeProofDescriptionOne:
    'Verify your identity. We will ask you for a photo and identification.',
  onbLifeProofDescriptionTwo:
    'If you are not the shareholder {{name}}, share the link.',
  onbLifeProofObtainLinkButton: 'Obtain link',
  onbLifeProofVerifyButton: 'Verify my identity',
  onbLifeProofVerificationLinkTitle: 'Verification link',
  onbLifeProofVerificationLinkDescription:
    'Send the following link to the corresponding shareholder',
  onbLifeProofVerificationLinkTooltip: 'Copied',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const LIFE_PROOF_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    onbLifeProofStatusApproved: 'Verificación completada',
    onbLifeProofStatusDeclined:
      'Ocurrió un error con tu verificación. Por favor, inténtalo nuevamente.',
    onbLifeProof: 'Verificación de identidad',
    onbLifeProofDescriptionOne:
      'Verifica tu identidad. Te pediremos una foto junto con una identificación.',
    onbLifeProofDescriptionTwo:
      'Si no eres el accionista {{name}}, compártele el enlace.',
    onbLifeProofObtainLinkButton: 'Obtener enlace',
    onbLifeProofVerifyButton: 'Verificar mi identidad',
    onbLifeProofVerificationLinkTitle: 'Enlace de verificación',
    onbLifeProofVerificationLinkDescription:
      'Envía el siguiente link al accionista correspondiente',
    onbLifeProofVerificationLinkTooltip: 'Copiado',
  },
};

export default LIFE_PROOF_LABELS;
